import { MatMenuModule } from '@angular/material/menu';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { LanguageModule } from '../language/language.module';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NavigationConfig } from './navigation-config';
import { TranslationModule } from '../translation/translation.module';
import { ShoppingcartModule } from '../shoppingcart/shoppingcart.module';
import { FooterModule } from '../footer/footer.module';
import { NavigationregeneroComponent } from './navigationregenero/navigationregenero.component';





@NgModule({
    declarations: [NavigationComponent,NavigationregeneroComponent],
    exports: [NavigationComponent,NavigationregeneroComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],

    imports: [
        CommonModule,
        LanguageModule,
        RouterModule,
        TranslationModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MatIconModule,
        MatDividerModule,
        MatDialogModule,
        MatSelectModule,
        MatMenuModule,
        ShoppingcartModule,
        MatButtonModule,
        MatMenuModule,
        FooterModule






    ]
})
export class NavigationModule {
    static forRoot(clientConfig?: NavigationConfig): ModuleWithProviders<NavigationModule> {
        const finalConfig = new NavigationConfig();
        if (clientConfig) {
            if (clientConfig.navigationMenuConfigPath) finalConfig.navigationMenuConfigPath = clientConfig.navigationMenuConfigPath;
        }
        return {
            ngModule: NavigationModule,
            providers: [
                {
                    provide: NavigationConfig,
                    useValue: finalConfig
                }
            ]
        };
    }
}
